import {useState} from "react";
import {Table, Modal} from 'antd';

import PageHeading from "../../shared/containers/PageHeading";
import LiveSearch from "../../modules/LiveSearch";
import PageStatistics from "../../modules/PageStatistics";
import PageFilters from "../../modules/PageFilters";
import ClientCard from "../../modules/CLientCard";

import {columns} from "./table";
import stats, {getTotalMissions, getTotalValue, getTotalTime, searchFunction, getTotalCarbonSaved, getResultData, createAddressOptions} from "./stats";

import useAll from "../../shared/hooks/useAll";

import {getAllData} from "../../shared/services/delegates";

import TotalCount from "../../shared/components/TotalCount/TotalCount";

const DelegatesPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);

    const {
        search,
        statsVisible,
        filteredInfo,
        sortedInfo,
        data,
        currentData,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    } = useAll({fetchData: getAllData, searchFunction});

    const showDetails = (id) => {
        setModalOpen(true);
        const element = data.hits.find(item => item.id === id);
        setModalContent(element);
    }

    const columnsConfig = [...columns];

    columnsConfig[1].filteredValue = filteredInfo.status || null;

    columnsConfig[0].sortOrder = sortedInfo.columnKey === 'name' ? sortedInfo.order : null;
    columnsConfig[2].sortOrder = sortedInfo.columnKey === 'email' ? sortedInfo.order : null;
    columnsConfig[3].sortOrder = sortedInfo.columnKey === 'phone' ? sortedInfo.order : null;
    columnsConfig[4].sortOrder = sortedInfo.columnKey === 'address_country' ? sortedInfo.order : null;
    columnsConfig[5].sortOrder = sortedInfo.columnKey === 'address_city' ? sortedInfo.order : null;
    columnsConfig[6].sortOrder = sortedInfo.columnKey === 'missions' ? sortedInfo.order : null;
    columnsConfig[7].sortOrder = sortedInfo.columnKey === 'value' ? sortedInfo.order : null;

    columnsConfig[0].render = (text, record) => <span onClick={() => showDetails(record.id)}>{text}</span>;


    const searchData = getResultData(data, search, countries, cities);
    const searchCurrentData = getResultData(currentData, search, countries, cities);

    const {hits} = searchData;

    const totalTime = getTotalTime(searchCurrentData.missions)
    const totalValue = getTotalValue(searchCurrentData.missions)

    const statsValue = {
        totalMissions: getTotalMissions(searchCurrentData.missions),
        totalValue,
        avgMissionValue: (totalValue / searchCurrentData.missions?.length).toFixed(2),
        avgTime: (totalTime / searchCurrentData.missions?.length).toFixed(1),
        totalTime,
        totalCarbonSaved: getTotalCarbonSaved(searchCurrentData.missions),
    }


    return (
        <>
            <PageHeading title="Delegates" subtitle="Everything about Delegates">
                <LiveSearch toogleStatsVisible={toogleStatsVisible} onChange={handleSearch} statsVisible={statsVisible} />
            </PageHeading>
            {statsVisible && <PageStatistics items={stats} values={statsValue}/>}
            <PageFilters  selectCountry={setCountries} selectCity={setCities} countries={createAddressOptions(searchCurrentData.countries)} cities={createAddressOptions(searchCurrentData.cities)}>
                {/*<UsersFilters/>*/}
            </PageFilters>
            <Table columns={columnsConfig} dataSource={hits} loading={loading} pagination={pagination}
                   onChange={handleChange}/>
            <TotalCount total={searchCurrentData?.hits?.length} />
            <Modal visible={modalOpen} onCancel={() => setModalOpen(false)} footer={null}>
                <ClientCard {...modalContent} />
            </Modal>
        </>
    )
}

export default DelegatesPage;
